import type { SVGProps } from "react";
import * as React from "react";

const SvgHardDrive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22 12h1a1 1 0 0 0-.106-.448zM2 12l-.894-.448A1 1 0 0 0 1 12zm3.45-6.89.894.448.002-.003zM2 18H1zM18.55 5.11l-.896.445.002.003zM16.76 4V3zM7.24 4V3zM6 15a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM10 15a1 1 0 1 0 0 2zm.01 2a1 1 0 1 0 0-2zM22 11H2v2h20zM4.556 4.662l-3.45 6.89 1.788.896 3.45-6.89zM1 12v6h2v-6zm0 6a3 3 0 0 0 .879 2.121l1.414-1.414A1 1 0 0 1 3 18zm.879 2.121A3 3 0 0 0 4 21v-2a1 1 0 0 1-.707-.293zM4 21h16v-2H4zm16 0a3 3 0 0 0 2.121-.879l-1.414-1.414A1 1 0 0 1 20 19zm2.121-.879A3 3 0 0 0 23 18h-2a1 1 0 0 1-.293.707zM23 18v-6h-2v6zm-.106-6.448-3.45-6.89-1.788.896 3.45 6.89zm-3.448-6.887A3 3 0 0 0 18.34 3.45l-1.054 1.7a1 1 0 0 1 .368.405zM18.34 3.45A3 3 0 0 0 16.76 3v2a1 1 0 0 1 .526.15zM16.76 3H7.24v2h9.52zM7.24 3a3 3 0 0 0-1.58.45l1.054 1.7A1 1 0 0 1 7.241 5zm-1.58.45a3 3 0 0 0-1.106 1.215l1.792.89a1 1 0 0 1 .368-.405zM6 17h.01v-2H6zm4 0h.01v-2H10z"
    />
  </svg>
);
export default SvgHardDrive;
